/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo, useState, useEffect, useContext } from 'react';
import PropTypes, { object } from 'prop-types';
import { Box, Button, IconButton, Tooltip, TextField } from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import {
  GetProcesso,
  isValid,
  transformJson,
  transformResponse,
} from 'src/services/auth';
import CustomInput from '../customInput';

import { LoadGif } from '../LoadGif';

import { ReactComponent as Select } from 'src/assets/icons/select.svg';

import { LogContext } from '../LogProvider';

export default function MinimalTable({
  onClose,
  porta,
  SetSearch,
  aditionalParams,
  Title,
  Filtro,
  SelectedItem,
}) {
  const { setLogData } = useContext(LogContext);
  const [data, setData] = useState([]);

  const [load, setLoad] = useState(true);
  const idEmp = localStorage.getItem('idEmp');
  const idFil = localStorage.getItem('idFil');

  const [filtrosCCU, setFiltrosCCU] = useState();
  const [filtrosNV, setFiltrosNV] = useState();

  useEffect(() => {
    if (isValid(Filtro)) {
      setFiltrosCCU(Filtro.centroDeCusto.map((item, index) => item.codccu));
    }

    if (isValid(SelectedItem)) {
      setFiltrosNV(
        Filtro.centroDeCusto
          .find((item) => item.codccu === SelectedItem)
          .nv.dados.map((item, index) => item.codinv)
      );
    }

    const data = {
      codemp: idEmp,
      codfil: idFil,
      cordord: 8,
      tipAca: 'acao',
      ...aditionalParams,
    };

    GetProcesso(porta, data, true, true).then((res) => {
      setLoad(false);

      const extractJson = res.dadosGerais || [];

      /*const transformedData = extractJson?.map((item) => {
        return item.reduce((acc, child) => {
          acc[child.name] = child.value;
          return acc;
        }, {});
      });*/

      setData(extractJson);
    });
  }, [porta]);

  const columns = useMemo(() => {
    if (data.length === 0) return [];

    return Object.keys(data[0])
      .filter((key) => key !== 'corlin' && key !== 'cortex')
      .map((key) => ({
        header: key.toUpperCase(),
        accessorKey: key,
      }));
  }, [data]);

  const subFormTable = useMaterialReactTable({
    columns,
    data,
    initialState: { showGlobalFilter: true, density: 'compact' },

    enableRowSelection: false,
    enableColumnOrdering: false,
    enableGlobalFilter: true,
    enableSorting: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: true,
    enableColumnActions: false,
    enableEditing: true,

    enableStickyHeader: false,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    muiTableContainerProps: {
      sx: { height: '40vh', width: '100%' },
    },

    muiTableBodyCellProps: ({ cell }) => ({
      style: { cursor: 'pointer' },
    }),
    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => {
        SetSearch(row.original);
      },
      sx: {
        cursor: 'pointer',
        backgroundColor:
          filtrosCCU?.includes(row.original.codcta) ||
          filtrosNV?.includes(row.original.codcta)
            ? '#eeeeee'
            : 'inherit',
        opacity:
          filtrosCCU?.includes(row.original.codcta) ||
          filtrosNV?.includes(row.original.codcta)
            ? '0.5'
            : 'inherit',
        pointerEvents:
          filtrosCCU?.includes(row.original.codcta) ||
          filtrosNV?.includes(row.original.codcta)
            ? 'none'
            : 'inherit',
      },
    }),

    muiTablePaperProps: {
      sx: {
        boxShadow: 'none',
      },
    },

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Selecionar">
          <IconButton>
            <Select className="tableIcon stroke" />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    localization: MRT_Localization_PT_BR,
  });

  return (
    <span className="minimalTable">
      {load && <LoadGif />}

      {!load && <h3> Selecionar {Title} </h3>}
      {!load && (
        <div>
          <Box
            sx={{
              width: '100%',
              border: '1px solid lightgray',
              marginBottom: '20px',
              minWidth: '35vw',
            }}
          >
            <MaterialReactTable table={subFormTable} />
          </Box>
        </div>
      )}
      {!load && (
        <button className="mainButton red" onClick={onClose}>
          retornar
        </button>
      )}
    </span>
  );
}

MinimalTable.propTypes = {
  onClose: PropTypes.func.isRequired,
  SetSearch: PropTypes.func.isRequired,
  porta: PropTypes.string,
};
